import NarutoAnime from './assets/NarutoAnime.jpg';

export const animeData =[
    {   
        key:"1",
        anime:"Naruto",
        episodes:"720",
        img:NarutoAnime,
        genre:'Adventure, fantasy comedy, martial arts.'
    }
]